// extracted by mini-css-extract-plugin
export default {"body":"cardSection_body__ZAHep","line":"cardSection_line__7cOkv","dishContainer":"cardSection_dishContainer__FWSWG","sectionContainer":"cardSection_sectionContainer__e1RIc"};